<template>
  <div>
    <Navigation/>
    <v-container>
        <v-card>
            <v-card-title>
            Secretary Audit Logs
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
            ></v-text-field>
            </v-card-title>
            <v-data-table
              :loading="isFetchingData"
              item-key="id"
              :headers="headers"
              :items="audit_logs"
              :search="search"
            ></v-data-table>
        </v-card>    
    </v-container>

  </div>
</template>

<script>
import { get_secretary_audit_logs } from '../api'
import Navigation from '../components/Navigation'
import store from '../store'
import moment from 'moment'

export default {
    components: {
        Navigation
    },
    data () {
      return {
        isFetchingData: true,
        search: '',
        headers: [
          {
            text: 'Date Updated',
            align: 'start',
            value: 'formatted_updated_date',
          },
          { text: 'Updated by', value: 'modified_by' },
          {
            text: 'Appointment Date',
            value: 'formatted_appointment_date',
          },
          { text: 'Previous State', value: 'previous_state' },
          { text: 'Updated State', value: 'current_state' },
          { text: 'Service Provider', value: 'scheduled_by' },
          { text: 'Client', value: 'scheduled_to' },
        ],
        audit_logs: []
      }
    },
    mounted() {
      const jwt = store.getters.getJwt
      get_secretary_audit_logs(jwt).then(response => {
          for (var auditLog of response.data.audit_logs) {
            auditLog.formatted_appointment_date = moment(auditLog.date_appointment_start).format('lll')
            auditLog.formatted_updated_date = moment(auditLog.updated_date).format('lll')
            this.audit_logs.push(auditLog)
          }
        this.isFetchingData = false
      })

    }

}
</script>

<style>

</style>